export default __webpack_public_path__ + "static/media/Corpay x Alpha LockUp_French - Corporate - Vertical - White.91b11324.svg";